import { render, staticRenderFns } from "./ArticleTemplateIndex引入其他项目.vue?vue&type=template&id=622f71c4&scoped=true"
import script from "./ArticleTemplateIndex引入其他项目.vue?vue&type=script&lang=js"
export * from "./ArticleTemplateIndex引入其他项目.vue?vue&type=script&lang=js"
import style0 from "./ArticleTemplateIndex引入其他项目.vue?vue&type=style&index=0&id=622f71c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f71c4",
  null
  
)

export default component.exports